import { render, staticRenderFns } from "./EntregasMenu.vue?vue&type=template&id=7815702a&scoped=true"
import script from "./EntregasMenu.vue?vue&type=script&lang=js"
export * from "./EntregasMenu.vue?vue&type=script&lang=js"
import style0 from "./EntregasMenu.vue?vue&type=style&index=0&id=7815702a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7815702a",
  null
  
)

export default component.exports